// 获取文件类型
export const getFileType = (imgObj: string) => {
  // 1: 图片  2： paf  3： word  4: txt  5 zip 6 excel 7 ppt 8 other
  let val = 1;
  const SrcArr = imgObj.split(".");
  if (SrcArr.includes("pdf") || SrcArr.includes("PDF")) {
    val = 2;
  } else if (SrcArr.includes("doc") || SrcArr.includes("docx")) {
    val = 3;
  } else if (SrcArr.includes("txt")) {
    val = 4;
  } else if (SrcArr.includes("zip") || SrcArr.includes("rar")) {
    val = 5;
  } else if (
    SrcArr.includes("excel") ||
    SrcArr.includes("xlsx") ||
    SrcArr.includes("xls")
  ) {
    val = 6;
  } else if (SrcArr.includes("ppt")) {
    val = 7;
  } else if (
    SrcArr.includes("jpg") ||
    SrcArr.includes("png") ||
    SrcArr.includes("jpeg") ||
    SrcArr.includes("gif") ||
    SrcArr.includes("JPG") ||
    SrcArr.includes("PNG") ||
    SrcArr.includes("JPEG") ||
    SrcArr.includes("GIF")
  ) {
    val = 1;
  } else {
    val = 8;
  }
  return val;
};

//校验是否为空
export const isEmpty = (obj: string) => {
  if (typeof obj == undefined || obj == null || obj === "" || obj == "null") {
    return true;
  } else {
    return false;
  }
}


//数小于等于最小数
export const minCompare = (num:string, min:string) => {
  if (parseInt(num) < parseInt(min)) {
    return false
  } else {
    return true
  }
}

//数大于等于最大数
export const maxCompare = (num:string, max:string) => {
  if (parseInt(num) > parseInt(max)) {
    return false
  } else {
    return true
  }
}

//最多输入2位小数
export const towDecimal = (num:string) => {
  const reg = /^(-?\d+)(\.\d{1,2})?$/;
  if (!reg.test(num)) {
    return false;
  } else {
    return true;
  }
}

//输入数字处理为小数点两位数
// export const twoDigits = (num:string) => {
//   num = num.match(/\d+(\.\d{0,2})?/)
//   ? num.match(/\d+(\.\d{0,2})?/)[0]
//   : "";
// }

